module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/arch.json
// module id = 364
// module chunks = 72316915199843